import { useEffect, useState } from 'react'
import { GetCategoriesByCurrentCategory, GetCategoriesBySearchingProducts, GetCategoriesForHomePage, GetRootCategories } from '../../../Services/AssortCategoriesService'
import { useConfig } from '../../../Providers/ConfigProvider'
import axios from 'axios'
import useDebounce from '../../../Hooks/useDebounce'

const useHandleCategories = (activeCategory, productsFilter) => {
    const { useDebounceWithStrongValueCheck } = useDebounce()
    const { api } = useConfig()
    const [categoriesForHomePage, setCategoriesForHomePage] = useState([])//DK : Produkty na stronie głównej, nie reaguja na zmiany filtrów
    const [rootCategories, setRootCategories] = useState([]) //DK : poziom 0 w produktach trigger na ilości po zmianie filtrów
    const [categoryData, setCategoryData] = useState(null)
    const [isLoadingCategoriesForHomePage, setIsLoadingCategoriesForHomePage] = useState(true)
    const [isLoadingRootCategories, setIsLoadingRootCategories] = useState(true)
    const [isLoadingCategoryData, setIsLoadingCategoryData] = useState(false)

    const debouncedFilter = useDebounceWithStrongValueCheck(productsFilter, 300)

    useEffect(() => {
        const source = axios.CancelToken.source()
        handleGetCategoriesForHomePage(source.token)
        return () => source.cancel()
    }, [JSON.stringify(api)])

    useEffect(() => {
        const source = axios.CancelToken.source()

        if (activeCategory) {
            handleGetCategoriesByCurrentCategory(debouncedFilter, source.token)
        }
        else {
            handleGetRootCategories(debouncedFilter, true, source.token)
        }

        return () => source.cancel()

    }, [JSON.stringify(debouncedFilter)]) //activeCategory

    // const handleGetRootCategories = async (api, productsFilter, setLoading, cancelToken) => {
    //     if (setLoading) { //DK : Aby nie mrugało w trakcie stosowania filtrów
    //         setIsLoadingRootCategories(true)
    //     }

    //     try {
    //         const res = await GetRootCategories(api, productsFilter, cancelToken)
    //         setRootCategories(res.data)
    //         setIsLoadingRootCategories(false)
    //     } catch (error) {
    //         if (axios.isCancel(error)) {
    //             return []
    //         }
    //         console.log(error)
    //         setRootCategories([])
    //     }
    // }

    const handleGetRootCategories = async (filter, setLoading, cancelToken) => {
        if (setLoading) {
            setIsLoadingRootCategories(true)
        }
        try {
            const res = await GetRootCategories(api, filter, cancelToken)
            setRootCategories(res.data)
        } catch (error) {
            if (!axios.isCancel(error)) {
                console.log(error)
                setRootCategories([])
            }
        } finally {
            if (setLoading) {
                setIsLoadingRootCategories(false)
            }
        }
    }

    const handleGetCategoriesForHomePage = async (cancelToken) => {
        setIsLoadingCategoriesForHomePage(true)
        try {
            const res = await GetCategoriesForHomePage(api, cancelToken)
            setCategoriesForHomePage(res.data)
            setIsLoadingCategoriesForHomePage(false)
        } catch (error) {
            console.log(error)
            setCategoriesForHomePage([[]])
        }
    }

    const handleGetCategoriesBySearchingProducts = async (artsCatOrSymbol) => {
        let tmpProductFilter = productsFilter
        tmpProductFilter.ArtCatOrSymbolList = artsCatOrSymbol
        try {
            var res = await GetCategoriesBySearchingProducts(api, tmpProductFilter)
            return res.data
        } catch (error) {
            console.log(error)
            return null
        }
    }

    // const handleGetCategoriesByCurrentCategory = async (cancelToken) => {
    //     if (activeCategory) {
    //         try {
    //             if (activeCategory.length > 1) {
    //                 const categories = activeCategory.map(c => GetCategoriesByCurrentCategory(c.nodeId, api, productsFilter, cancelToken))
    //                 const results = await Promise.all(categories)
    //                 const allCategoriesData = results.map(res => res.data)
    //                 setCategoryData(allCategoriesData)
    //             }
    //             else {
    //                 const nodeId = activeCategory.nodeId ? activeCategory.nodeId : activeCategory[0].nodeId
    //                 const res = await GetCategoriesByCurrentCategory(nodeId, api, productsFilter)
    //                 setCategoryData(res.data)
    //             }
    //         } catch (error) {
    //             if (axios.isCancel(error)) {
    //                 return []
    //             }
    //             console.log(error)
    //         }
    //     }
    // }

    const handleGetCategoriesByCurrentCategory = async (filter, cancelToken) => {
        if (!activeCategory) {
            return
        }
        setIsLoadingCategoryData(true)
        try {
            if (Array.isArray(activeCategory) && activeCategory.length > 1) {
                const categoriesPromises = activeCategory.map(c =>
                    GetCategoriesByCurrentCategory(c.nodeId, api, filter, cancelToken)
                )
                const results = await Promise.all(categoriesPromises)
                const allCategoriesData = results.map(res => res.data)
                setCategoryData(allCategoriesData)
            } else {
                const nodeId = activeCategory.nodeId || (Array.isArray(activeCategory) ? activeCategory[0]?.nodeId : null)
                if (!nodeId) {
                    return
                }
                const res = await GetCategoriesByCurrentCategory(nodeId, api, filter, cancelToken)
                setCategoryData(res.data)
            }
        } catch (error) {
            if (!axios.isCancel(error)) {
                console.log(error)
            }
        }
        finally {
            setIsLoadingCategoryData(false)
        }
    }

    return {
        categoriesForHomePage,
        categoryData,
        handleGetCategoriesBySearchingProducts,
        isLoadingCategoriesForHomePage,
        rootCategories,
        isLoadingRootCategories,
        isLoadingCategoryData
    }
}

export default useHandleCategories